import React from "react";
import "../styles/AboutMe.css";
import profilePhoto from "../assets/kf-aboutme.png";

function AboutMe() {
  return (
    <div class="about-container">
      <div class="about-left">
        <h1>About Me</h1>
        <img src={profilePhoto} alt="Profile Picture" />
      </div>
      <div class="about-right">
        <p>
          I was born and raised in Kansas City (go Chiefs!). My hobbies include
          cooking, baking (even though I’m not great at it), running, and
          enjoying wine—any and all types.
        </p>
        <p>
          Travel is a huge part of my life. In 2022, I lived out of a van for
          two months, exploring every state west of Kansas, visiting eight
          national parks, and discovering countless cities. The following
          summer, I backpacked across Europe, which was truly the experience of
          a lifetime! I firmly believe in spending money on experiences rather
          than things and making the most of every moment.
        </p>
        <p>
          I got into programming thanks to my dad, who introduced me to coding
          at a young age. I quickly discovered I had a knack for it.
        </p>
        <p>
          In college, I debated between computer science and chasing a distant
          dream of becoming a vet. I took a bio class and a programming
          class—got a D in bio and an A in programming—so my path forward became
          pretty clear. I fell in love with the idea of creating anything from
          code. The creative possibilities are endless.
        </p>
        <p>
          I’ve always been a creative person, which is why frontend development
          caught my eye. But along the way, through personal projects and app
          ideas, I picked up backend technologies as well, rounding out my
          skills as a full-stack developer. Not only do I love coding, but I
          love that it pushes me to learn something new every day. There’s
          always a new concept to explore, a better way to solve a problem, or
          an idea to build out.
        </p>
      </div>
    </div>
  );
}

export default AboutMe;
